module.exports = __webpack_public_path__ + "static/term-life-insurance-hero.6a00036e.webp";